import keyMirror from 'react-utils/keyMirror';
export const UserTrackStatuses = keyMirror({
  NOT_STARTED: null,
  IN_PROGRESS: null,
  COMPLETED: null,
  EXPIRING_SOON: null
});
export const AWARD_VISIBILITIES = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE'
};